const ROTAS_COM_TOKEN: RegExp[] = [/(\/convite\/)[^/?#&]+/g];

export function ocultarTokensDaUrl(url: string): string {
  if (!url) return url;

  return ROTAS_COM_TOKEN.reduce(
    (limpa, padrao) => limpa.replace(padrao, '$1:token'),
    url
  );
}
